module.exports = __webpack_public_path__ + "img/nothing-found.8d0d0b35.svg";